(() => {
    const content = document.querySelector('.article-template__content');
    const articleHandle = window.location.pathname.replace(/^\/blogs\//, '');
    const isGemstoneElevenCleanup = [
      'title-unleash-creativity-with-hematoid-gemstone-beads-for-stunning-jewelry-designs',
      'title-unveiling-the-enchanting-world-of-hemimorphite-gemstone-beads-for-jewelry-making',
      'unveiling-the-enchantment-mastering-hyperstine-gemstone-beads-for-jewelry-making',
      'unveiling-the-enchantment-of-apache-tear-gemstone-beads-a-comprehensive-guide-for-jewelry-makers',
      'discover-the-enchanting-world-of-zoisite-gemstone-beads-for-jewelry-making',
      'title-tiffany-gemstone-beads-a-jewelry-makers-guide-to-quality-and-authenticity-from-rezagemcollection',
      'discover-the-magic-of-golden-healer-gemstone-beads-a-comprehensive-guide-for-jewelry-makers',
      'unveiling-the-radiance-tiffany-stone-gemstone-beads-for-jewelry-makers',
      'unveiling-the-enchanting-world-of-jet-gemstone-beads-a-comprehensive-guide-for-jewelry-makers',
      'discover-the-power-of-hematite-gemstone-beads-your-ultimate-guide-for-jewelry-makers',
      'unveiling-the-majesty-of-k2-gemstone-beads-a-comprehensive-guide-for-jewelry-makers',
      'unveiling-the-magical-world-of-yooperlite-gemstone-beads-a-comprehensive-guide-for-jewelry-makers',
      'exploring-tiger-iron-gemstone-beads-a-comprehensive-guide-for-jewelry-makers',
      'unleashing-creativity-exploring-stichtite-gemstone-beads-for-jewelry-making',
      'discover-the-enchanting-world-of-phosphorite-gemstone-beads-for-jewelry-making',
      'unveiling-opalite-gemstone-beads-a-guide-for-jewelry-makers',
      'unveiling-the-enchanting-world-of-trolleite-gemstone-beads',
      'discover-the-enchanting-allure-of-celestite-gemstone-beads-for-jewelry-making',
      'unveiling-the-enchantment-of-merlinite-gemstone-beads-a-comprehensive-guide-for-jewelry-makers',
      'unveiling-the-enchanting-world-of-mangano-gemstone-beads-for-jewelry-making',
      'unveiling-the-enchanting-world-of-hyperstene-gemstone-beads-a-treasure-trove-for-jewelry-makers',
      'unveiling-the-magic-phantom-gemstone-beads-for-your-next-jewelry-masterpiece',
      'unveiling-the-enchantment-phosphosiderite-gemstone-beads-for-jewelry-making',
      'exploring-diopside-gemstone-beads-a-comprehensive-guide-for-jewelry-makers',
      'title-unveiling-the-enchanting-world-of-chalcedony-gemstone-beads-for-jewelry-making',
      'discover-the-charm-and-versatility-of-mother-of-pearl-gemstone-beads-for-jewelry-making',
      'unveiling-the-enchanting-world-of-chrysoprase-gemstone-beads-for-jewelry-making',
      'unveiling-the-enchantment-morganite-gemstone-beads-for-jewelry-making',
      'unveiling-the-enchanting-world-of-prehnite-gemstone-beads-for-jewelry-making',
      'title-mastering-jewelry-creations-with-stunning-epidote-gemstone-beads',
      'unveiling-the-allure-of-champagne-gemstone-beads-a-comprehensive-guide-for-jewelry-makers',
      'unveiling-the-enigmatic-allure-of-bronzite-gemstone-beads',
      'title-unleashing-creativity-a-guide-to-working-with-sandstone-gemstone-beads-for-jewelry-makers',
      'unveiling-the-enchanting-world-of-blossom-gemstone-beads-a-jewelry-makers-guide',
      'discovering-the-enchanting-world-of-black-silver-leaf-gemstone-beads',
      'pearl-gemstone-beads-a-comprehensive-guide-for-jewelry-makers',
      'title-discover-the-beauty-and-versatility-of-biotite-gemstone-beads-for-jewelry-making',
      'unveiling-the-beauty-of-feldspar-gemstone-beads-a-jewelry-makers-guide-to-designing-with-authenticity',
      'unveiling-the-enchantment-of-arusha-gemstone-beads-for-jewelry-making',
      'discover-the-enchanting-world-of-arfvedsonite-gemstone-beads-for-jewelry-making',
      'unleashing-creativity-smithsonite-gemstone-beads-for-jewelry-makers',
      'discover-the-enchanting-world-of-shattuckite-gemstone-beads-a-comprehensive-guide-for-jewelry-makers',
      'delve-into-the-radiant-world-of-pyrope-gemstone-beads-a-comprehensive-guide-for-jewelry-makers',
      'unleashing-creativity-pietersite-gemstone-beads-for-jewelry-making',
      'unleashing-creative-potential-exploring-lianite-gemstone-beads-for-jewelry-making',
      'unveiling-the-enchantment-of-calligraphy-gemstone-beads-for-jewelry-making',
      'unveiling-the-enchantment-tourmalinated-gemstone-beads-for-jewelry-making'
    ].some((handle) => articleHandle.includes(handle));
    const isRequestedArticle = [
      '/pink-tourmaline-jewelry-guide-rings-bracelets-and-birthstone-meaning',
      '/october-birthstone',
      '/unveiling-the-powerful-allure-of-shungite-gemstone-beads-a-comprehensive-guide-for-jewelry-makers',
      '/freshwater-pearl-beads',
      '/the-ultimate-guide-to-stone-beads',
      '/agate-crystal-beads',
      '/title-1',
      '/topaz-gemstones-meaning-price-and-more',
      '/custom-jewelry-in-canada-at-reza-gem-collection',
      '/azurite-malachite-a-stunning-blend-of-color-energy-and-beauty',
      '/how-to-choose-the-best-jewelry-making-supplies-for-your-designs',
      '/essential-jewellery-making-items'
    ].some((handle) => articleHandle.endsWith(handle)) || isGemstoneElevenCleanup;
    let widgetSelector = '.product-grid, .opal-showcase-grid, .product-showcase, .rondelle-polished-article-card, .rondelle-polished-article-card-button, .opal-cta-card, .agate-showcase';

    if (isRequestedArticle) {
      widgetSelector += ', .gemstone-cards-container, .featured-products-section, .image-container, .agate-gallery, .showcase-grid, .happy-customers-gallery-section, .card';
    }

    content.querySelectorAll(widgetSelector).forEach((widget) => {
      const heading = widget.previousElementSibling;

      if (heading && /^H[1-4]$/.test(heading.tagName)) {
        heading.remove();
      }

      widget.remove();
    });

    if (isRequestedArticle) {
      content.querySelectorAll('[style*="display: none"]').forEach((element) => element.remove());
      content.querySelectorAll('div[style*="background: #e6faf6"], div[style*="background:#e6faf6"]').forEach((promotion) => promotion.remove());
      content.querySelectorAll('b, strong').forEach((element) => element.replaceWith(...element.childNodes));
      content.querySelectorAll('[style]').forEach((element) => element.removeAttribute('style'));

      content.querySelectorAll('h2, h3').forEach((heading) => {
        const text = heading.textContent.trim();
        const wordCount = text.split(/\s+/).length;

        if (text.length > 140 || wordCount > 24) {
          const paragraph = document.createElement('p');
          paragraph.append(...heading.childNodes);
          heading.replaceWith(paragraph);
        }
      });

      const requestedTextWalker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
      let requestedTextNode;

      while ((requestedTextNode = requestedTextWalker.nextNode())) {
        requestedTextNode.nodeValue = requestedTextNode.nodeValue
          .replace(/#{1,6}\s+/g, '')
          .replace(/\*\*/g, '');
      }

      window.setTimeout(() => {
        content.querySelectorAll('[style*="display: none"]').forEach((element) => element.remove());
        content.querySelectorAll('[style]').forEach((element) => element.removeAttribute('style'));
      }, 500);
    }

    if (articleHandle.endsWith('/october-birthstone')) {
      const openingProductShowcase = Array.from(content.children).find((element) => {
        const inlineStyle = element.getAttribute('style') || '';
        return element.tagName === 'DIV' && inlineStyle.includes('display: flex') && element.querySelectorAll('img').length > 0;
      });

      openingProductShowcase?.remove();
    }

    if (articleHandle.endsWith('/october-birthstone') || articleHandle.endsWith('/agate-crystal-beads')) {
      content.querySelectorAll('[style*="display: none"]').forEach((element) => element.remove());

      content.querySelectorAll('div[style*="background: #e6faf6"], div[style*="background:#e6faf6"]').forEach((promotion) => {
        promotion.remove();
      });

      content.querySelectorAll('div[style*="text-align: center"]').forEach((card) => {
        if (card.querySelector('img')) {
          card.remove();
        }
      });

      content.querySelectorAll('img[style*="max-width: 300px"], img[style*="max-width:300px"]').forEach((image) => {
        image.remove();
      });

      content.querySelectorAll('b, strong').forEach((element) => element.replaceWith(...element.childNodes));
      content.querySelectorAll('[style]').forEach((element) => element.removeAttribute('style'));
    }

    const isSixArticleCleanup = [
      '/title-1',
      '/topaz-gemstones-meaning-price-and-more',
      '/custom-jewelry-in-canada-at-reza-gem-collection',
      '/azurite-malachite-a-stunning-blend-of-color-energy-and-beauty',
      '/how-to-choose-the-best-jewelry-making-supplies-for-your-designs',
      '/essential-jewellery-making-items'
    ].some((handle) => articleHandle.endsWith(handle));

    if (isSixArticleCleanup) {
      content.querySelectorAll('[style*="display: none"]').forEach((element) => element.remove());
      content.querySelectorAll('div[style*="background: #e6faf6"], div[style*="background:#e6faf6"]').forEach((promotion) => promotion.remove());
      content.querySelectorAll('b, strong').forEach((element) => element.replaceWith(...element.childNodes));
      content.querySelectorAll('[style]').forEach((element) => element.removeAttribute('style'));

      const articleTitle = document.querySelector('.article-template__title');
      if (articleTitle) {
        articleTitle.textContent = articleTitle.textContent.replace(/\*\*/g, '').trim();
      }
    }

    if (isGemstoneElevenCleanup) {
      content.querySelectorAll('[style*="display: none"]').forEach((element) => element.remove());
      content.querySelectorAll('div[style*="background: #e6faf6"], div[style*="background:#e6faf6"]').forEach((promotion) => promotion.remove());
      content.querySelectorAll('b, strong').forEach((element) => element.replaceWith(...element.childNodes));
      content.querySelectorAll('[style]').forEach((element) => element.removeAttribute('style'));

      content.querySelectorAll('h2, h3').forEach((heading) => {
        const text = heading.textContent.trim();
        const wordCount = text.split(/\s+/).length;

        if (text.length > 140 || wordCount > 24) {
          const paragraph = document.createElement('p');
          paragraph.append(...heading.childNodes);
          heading.replaceWith(paragraph);
        }
      });

      const gemstoneTextWalker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
      let gemstoneTextNode;

      while ((gemstoneTextNode = gemstoneTextWalker.nextNode())) {
        gemstoneTextNode.nodeValue = gemstoneTextNode.nodeValue
          .replace(/#{1,6}\s+/g, '')
          .replace(/\*\*/g, '');
      }

      const gemstoneArticleTitle = document.querySelector('.article-template__title');
      if (gemstoneArticleTitle) {
        gemstoneArticleTitle.textContent = gemstoneArticleTitle.textContent.replace(/\*\*/g, '').trim();
      }
    }

    if (articleHandle.includes('unveiling-the-allure-of-champagne-gemstone-beads-a-comprehensive-guide-for-jewelry-makers')) {
      const referenceParagraph = [...content.querySelectorAll('p')].find((paragraph) =>
        paragraph.textContent.trim().startsWith('[1] Champagne Garnet Polished Round Beads:')
      );

      if (referenceParagraph) {
        const referenceList = document.createElement('div');
        referenceList.className = 'article-reference-list';

        referenceParagraph.innerHTML
          .split(/\r?\n/)
          .map((reference) => reference.trim())
          .filter(Boolean)
          .forEach((reference) => {
            const referenceItem = document.createElement('p');
            referenceItem.className = 'article-reference-list__item';
            referenceItem.innerHTML = reference;
            referenceList.append(referenceItem);
          });

        referenceParagraph.replaceWith(referenceList);
      }
    }

    if (articleHandle.endsWith('/the-ultimate-guide-to-stone-beads')) {
      content.querySelectorAll('.MsoNormal').forEach((element) => element.classList.remove('MsoNormal'));
      content.querySelectorAll('b, strong').forEach((element) => element.replaceWith(...element.childNodes));
      content.querySelectorAll('[style]').forEach((element) => element.removeAttribute('style'));
    }

    if (articleHandle.endsWith('/unveiling-the-powerful-allure-of-shungite-gemstone-beads-a-comprehensive-guide-for-jewelry-makers')) {
      content.querySelectorAll('h2, h3').forEach((heading) => {
        const text = heading.textContent.trim();
        const wordCount = text.split(/\s+/).length;

        if (text.length > 140 || wordCount > 24) {
          const paragraph = document.createElement('p');
          paragraph.append(...heading.childNodes);
          heading.replaceWith(paragraph);
        }
      });

      const textWalker = document.createTreeWalker(content, NodeFilter.SHOW_TEXT);
      let textNode;

      while ((textNode = textWalker.nextNode())) {
        textNode.nodeValue = textNode.nodeValue
          .replace(/#{1,6}\s+/g, '')
          .replace(/\*\*/g, '');
      }
    }
  })();
